export class IdentifiableDto {
    id!: number;
}